import { r } from "./register-dHQ0x1Vq.js";
import { C as s } from "./register-dHQ0x1Vq.js";
r();
export {
  s as Checkbox
};
